import React, { useEffect, useState } from "react";
import useHttp from "../../../../hooks/use-http";
import { toast } from "react-toastify";

const AppForm = (props) => {
  const { mode, appData, onBack } = props;

  const { sendRequest: saveApp } = useHttp();

  const [saving, setSaving] = useState(false);

  const [form, setForm] = useState({
    appName: "",
    appIdentifier: "",
    bucket: "",
    productionPath: "",
    archivePath: "",
    description: "",
  });

  // ================= POPULATE ON EDIT =================
  useEffect(() => {
    if (mode === "edit" && appData) {
      setForm({
        appName: appData?.appName || "",
        appIdentifier: appData?.appIdentifier || "",
        bucket: appData?.bucket || "",
        productionPath: appData?.productionPath || "",
        archivePath: appData?.archivePath || "",
        description: appData?.description || "",
      });
    }
  }, [mode, appData]);

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const submitHandler = (e) => {
    e.preventDefault();

    if (
      !form.appName ||
      !form.appIdentifier ||
      !form.bucket ||
      !form.productionPath ||
      !form.archivePath
    ) {
      toast.warning("Please fill all required fields");
      return;
    }

    const orgId = localStorage.getItem("orgId");
    const userId = localStorage.getItem("userId");

    const payload = {
      appName: form.appName,
      appIdentifier: form.appIdentifier,
      bucket: form.bucket,
      productionPath: form.productionPath,
      archivePath: form.archivePath,
      description: form.description,
      orgId: orgId,
    };

    if (mode === "add") {
      payload.createdBy = userId;
    }
    if (mode === "edit") {
      payload.appId = appData?.appId;
      payload.modifiedBy = userId;
    }

    setSaving(true);

    saveApp(
      {
        url: `/api/app/`,
        method: mode === "edit" ? "PUT" : "POST",
        body: payload,
        headers: { "Content-Type": "application/json" },
      },
      (res) => {
        setSaving(false);

        if (!res) {
          toast.error("Something went wrong while saving the App");
          return;
        }

        toast.success(res?.message || res?.errorMessage || "Saved successfully");
        onBack();
      }
    );
  };

  return (
    <div className="content-wrapper">
      <section className="content">
        <div className="container-fluid">
          <div className="row">
            <div className="col-md-12">
              <div className="card card-default">
                <form onSubmit={submitHandler}>
                  <div className="card-header">
                    <h3 className="card-title">
                      {mode === "edit" ? "Edit App" : "Add App"}
                    </h3>
                  </div>

                  <div className="card-body">
                    <div className="row">
                      <div className="col-md-6">
                        <div className="form-group">
                          <label>
                            App Name <span className="text-danger">*</span>
                          </label>
                          <input
                            type="text"
                            className="form-control"
                            placeholder="App Name *"
                            name="appName"
                            value={form.appName}
                            onChange={handleChange}
                            required
                          />
                        </div>
                      </div>

                      <div className="col-md-6">
                        <div className="form-group">
                          <label>
                            App Identifier <span className="text-danger">*</span>
                          </label>
                          <input
                            type="text"
                            className="form-control"
                            placeholder="e.g. standard_farming"
                            name="appIdentifier"
                            value={form.appIdentifier}
                            onChange={handleChange}
                            required
                          />
                        </div>
                      </div>

                      <div className="col-md-6">
                        <div className="form-group">
                          <label>
                            Bucket <span className="text-danger">*</span>
                          </label>
                          <input
                            type="text"
                            className="form-control"
                            placeholder="e.g. techlogi-dev-gdb"
                            name="bucket"
                            value={form.bucket}
                            onChange={handleChange}
                            required
                          />
                        </div>
                      </div>

                      <div className="col-md-6">
                        <div className="form-group">
                          <label>
                            Production Path <span className="text-danger">*</span>
                          </label>
                          <input
                            type="text"
                            className="form-control"
                            placeholder="e.g. file/apk/testota/currentapk"
                            name="productionPath"
                            value={form.productionPath}
                            onChange={handleChange}
                            required
                          />
                        </div>
                      </div>

                      <div className="col-md-6">
                        <div className="form-group">
                          <label>
                            Archive Path <span className="text-danger">*</span>
                          </label>
                          <input
                            type="text"
                            className="form-control"
                            placeholder="e.g. file/apk/testota/archiveapk"
                            name="archivePath"
                            value={form.archivePath}
                            onChange={handleChange}
                            required
                          />
                        </div>
                      </div>

                      <div className="col-md-6">
                        <div className="form-group">
                          <label>Description</label>
                          <input
                            type="text"
                            className="form-control"
                            placeholder="Description (optional)"
                            name="description"
                            value={form.description}
                            onChange={handleChange}
                          />
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="card-footer text-right">
                    <button
                      type="button"
                      className="btn btn-secondary mr-2"
                      onClick={onBack}
                    >
                      Cancel
                    </button>
                    <button
                      type="submit"
                      className="btn btn-primary"
                      disabled={saving}
                    >
                      {saving ? "Saving..." : "Save"}
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default AppForm;